import cn from 'classnames';
import Image from 'next/image';
import { FC, useContext } from 'react';

import { ModalContext } from '~components/ModalProvider';
import useAuthUser from '~utils/hooks/useAuthUser';
import useMembership from '~utils/hooks/useMembership';

import CitiPremiaCard from '../../../public/img/citipremia.png';
import styles from './UserLoyalty.module.css';

interface AuthProps {
  fullname: string;
  cardNumber?: string;
  total?: number;
  level?: string;
}

const percentage: Record<string, number> = {
  'Nivel 1': parseFloat(process.env.LEVEL_1_POINTS_FACTOR || '0.05'),
  'Nivel 2': parseFloat(process.env.LEVEL_2_POINTS_FACTOR || '0.08'),
  'Nivel 3': parseFloat(process.env.LEVEL_3_POINTS_FACTOR || '0.1'),
};

const UserAuth = ({ fullname, total, level }: AuthProps) => (
  <div className={styles.copy}>
    <span>
      <strong>{fullname}</strong>, con esta compra ganarás{' '}
      {((total || 0) * percentage[level ?? '']).toFixed(1)} puntos, cada punto representa $1 peso,
      que puedes utilizar en nuestra dulcería.
    </span>
  </div>
);

const UserUnauth = () => {
  const context = useContext(ModalContext);

  return (
    <div className={cn(styles.mediaBody, styles.copy)}>
      <span>Inicia sesión y acumula puntos con tus compras.</span>
      <span>
        Conoce los <span>beneficios</span> de CitiPremia
      </span>
      <div className="mt-8 flex flex-row justify-center gap-2 md:mt-0 md:justify-start">
        <button
          className={styles.loginButton}
          onClick={() => {
            context.setModal('login');
          }}
          type="button"
        >
          Iniciar Sesión
        </button>
        <button
          className={styles.signupButton}
          onClick={() => {
            context.setModal('signup');
          }}
          type="button"
        >
          Crear cuenta
        </button>
      </div>
    </div>
  );
};

const UserAuthWithoundMembership = () => {
  const context = useContext(ModalContext);
  return (
    <div className={cn(styles.mediaBody, styles.copy)}>
      <span>Activa CitiPremia y acumula puntos con tus compras.</span>
      <div className="mt-8 flex flex-row justify-center gap-2 md:mt-0 md:justify-start">
        <button
          className={styles.signupButton}
          onClick={() => {
            window.location.hash = 'membershipActivation';
            context.setModal('signup');
          }}
        >
          Activar CitiPremia
        </button>
      </div>
    </div>
  );
};

const UserLoyalty: FC<{ total?: number }> = ({ total }) => {
  const user = useAuthUser();
  const membership = useMembership();
  return (
    <div className={cn(styles.root, styles.media, styles.mediaLarge)}>
      <div className={styles.mediaImg}>
        <Image
          src={CitiPremiaCard}
          width={126}
          height={81}
          className="object-cover"
          quality={100}
          alt="Imagen de la tarjeta CitiPremia"
        />
      </div>
      {!user ? (
        <UserUnauth />
      ) : !user?.Profile?.loyaltyActivated ? (
        <UserAuthWithoundMembership />
      ) : (
        user.Profile?.loyaltyActivated && (
          <UserAuth
            fullname={user?.name}
            cardNumber={user?.Profile?.loyaltyCard}
            total={total}
            level={membership?.data?.memberLevel}
          />
        )
      )}
    </div>
  );
};

export default UserLoyalty;
